export default __webpack_public_path__ + "static/media/our-process-two.ade7f12d.jpg";